module.exports = __webpack_public_path__ + "img/icon2-1-1024x1024.a9f0027f.png";